import { useEffect, useRef, useState } from 'react'

export const useScrollReveal = (options = {}) => {
    const [isVisible, setIsVisible] = useState(false)
    const ref = useRef(null)

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true)
                // Optionnel : arrêter d'observer après l'apparition
                if (options.once) {
                    observer.unobserve(entry.target)
                }
            } else if (!options.once) {
                setIsVisible(false)
            }
        }, {
            threshold: options.threshold || 0.1,
            rootMargin: options.rootMargin || '0px'
        })

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current)
            }
        }
    }, [options.threshold, options.rootMargin, options.once])

    return [ref, isVisible]
}